import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import { IAlbum } from '@/data/models/album';
import { IValidationResults } from '@/data/models/validation';
import { parseDate, parseMomentFromTime } from '@/utils/helper';
import { t } from 'i18next';
import { Moment } from 'moment';
import TimedReleaseDateTimePicker from '../../TimedReleaseDateTimePicker/TimedReleaseDateTimePicker';
import { FormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';
import React from 'react';
import { VALIDATION_STATE_WARNING } from '@/utils/validationErrors';

type Props = FormGroupProps & {
  albumErrors: IValidationResults[];
  onChangePreorderDate: boolean;
  setOnChangePreorderDate: (value: React.SetStateAction<boolean>) => void;
  handleAlbumMetaData: (field: string, value: string | null) => void;
  getPreviousReleaseDate: (album: IAlbum) => Date | undefined;
};

export default function RetailPreOrderDateFormGroup({
  albumErrors,
  onChangePreorderDate,
  album,
  setOnChangePreorderDate,
  handleAlbumMetaData,
  readonly,
  disabled,
  getPreviousReleaseDate,
}: Props) {
  const preOrderTime = parseMomentFromTime(
    album.albumMetaData?.retailPreOrderTime
  );
  const retailPreOrderDateIssue = albumErrors.find(
    (va) => va.fieldName === 'RetailPreOrderDate'
  );
  const validationClassName =
    retailPreOrderDateIssue && !onChangePreorderDate
      ? retailPreOrderDateIssue.isValid === VALIDATION_STATE_WARNING
        ? 'warning-input'
        : 'invalid-input'
      : '';
  const inputClassName = validationClassName
    ? `form-control ${validationClassName}`
    : 'form-control';
  const readOnlyText = album.albumMetaData?.retailPreOrderDate
    ? `${album.albumMetaData?.retailPreOrderDate}${preOrderTime ? ` ${preOrderTime.format('hh:mm A')} UTC` : ''}`
    : null;
  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey="tooltip.product.preOrderDate"
          hasErrors={!!retailPreOrderDateIssue}
        >
          <TimedReleaseDateTimePicker
            id="retailPreOrderDate"
            labelClassName="col-sm-3 form-label"
            label={t('product.editProduct.preOrderDate')}
            className={inputClassName}
            calendarClassName={validationClassName}
            date={parseDate(album.albumMetaData?.retailPreOrderDate)}
            time={parseMomentFromTime(album.albumMetaData?.retailPreOrderTime)}
            onDateChange={(e: any) => {
              setOnChangePreorderDate(true);
              handleAlbumMetaData('retailPreOrderDate', e);
            }}
            onTimeChange={(e: Moment | undefined | null) => {
              setOnChangePreorderDate(true);
              handleAlbumMetaData(
                'retailPreOrderTime',
                e?.startOf('minute').format('HH:mm:ss') ?? null
              );
            }}
            disabled={disabled}
            maxDate={getPreviousReleaseDate(album)}
          ></TimedReleaseDateTimePicker>
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'retailPreOrderDate'}
          labelTitle={t('product.editProduct.preOrderDate')}
          value={readOnlyText}
        ></ReadOnlyField>
      )}
    </>
  );
}
